import PingSearchRoute from './PingSearchRoute'
import PingMyMilestonesRoute from './PingMyMilestonesRoute'

const routes = [
    new PingSearchRoute(),
    new PingMyMilestonesRoute()
]

export default routes
